import { PublicLayout } from "@/layouts/PublicLayout";

export default function Privacy() {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-2xl px-4 py-12 space-y-8 text-foreground">
        <h1 className="text-3xl font-bold">Personvernerklæring</h1>
        <p className="text-muted-foreground">Sist oppdatert: 22. februar 2026</p>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">1. Behandlingsansvarlig</h2>
          <p>
            Inwent AS, org.nr. 834 661 012, er behandlingsansvarlig for personopplysninger
            som samles inn gjennom Flyt. Kontakt oss på{" "}
            <a href="mailto:hei@inwent.no" className="text-primary underline">hei@inwent.no</a>.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">2. Hvilke data vi samler inn</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>E-postadresse (ved registrering)</li>
            <li>Familiedata du oppretter (barns fornavn, emoji-avatar)</li>
            <li>Gjøremål, daglige oppgaver og sjekklister</li>
            <li>Samværskalender og overleveringsnotater</li>
            <li>Skjermtid-innstillinger og poeng</li>
          </ul>
          <p>
            Vi samler <strong>ikke</strong> inn fødselsdato, etternavn, bilder eller
            lokasjonsdata. Barn trenger ikke oppgi e-post eller andre personopplysninger.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">3. Formål og rettslig grunnlag</h2>
          <p>
            Vi behandler personopplysninger for å levere tjenesten du har registrert deg for.
            Rettslig grunnlag er GDPR art.&nbsp;6(1)(b) – oppfyllelse av avtale.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">4. Lagring og sikkerhet</h2>
          <p>
            All data lagres i EU. Vi benytter krypterte forbindelser (TLS) og
            tilgangskontroll på databasenivå. Vi selger aldri data, viser ingen annonser
            og bruker ingen tredjeparts sporingsverktøy.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">5. Deling av data</h2>
          <p>
            Vi deler ikke personopplysninger med tredjeparter, med unntak av
            betalingsformidler (Stripe) for håndtering av abonnementer. Stripe behandler
            kun betalingsdata og har egen personvernerklæring.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">6. Barn og personvern</h2>
          <p>
            Flyt er designet slik at barn ikke trenger egen konto eller e-postadresse.
            Barnets enhet kobles til familien via en paringskode som foreldre genererer.
            Vi lagrer kun fornavn og en emoji-avatar for hvert barn.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">7. Dine rettigheter</h2>
          <p>Du har rett til å:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Be om innsyn i dine personopplysninger</li>
            <li>Kreve retting av uriktige opplysninger</li>
            <li>Be om sletting av din konto og tilhørende data</li>
            <li>Be om dataportabilitet</li>
            <li>Klage til Datatilsynet</li>
          </ul>
          <p>
            Kontakt oss på{" "}
            <a href="mailto:hei@inwent.no" className="text-primary underline">hei@inwent.no</a>{" "}
            for å utøve dine rettigheter.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">8. Informasjonskapsler</h2>
          <p>
            Flyt bruker kun nødvendige informasjonskapsler for innlogging og
            sesjonshåndtering. Vi bruker ingen analyse- eller markedsføringscookies.
          </p>
        </section>

        <section className="space-y-3">
          <h2 className="text-xl font-semibold">9. Endringer</h2>
          <p>
            Vi kan oppdatere denne erklæringen ved behov. Vesentlige endringer varsles
            i appen.
          </p>
        </section>
      </div>
    </PublicLayout>
  );
}
